// Assumindo que esta é a função que você já tem
export async function convertHeicToWebp(file: File): Promise<File> {
  // Verificar se o arquivo é realmente HEIC antes de importar o módulo
  if (!file.name.toLowerCase().endsWith(".heic") && file.type !== "image/heic") {
    // Se não for HEIC, apenas retornar o arquivo original
    return file
  }

  try {
    // Importar heic2any apenas quando necessário
    const heic2any = (await import(/* webpackChunkName: "heic2any" */ "heic2any")).default

    const convertedBlob = await heic2any({
      blob: file,
      toType: "image/webp",
      quality: 0.8, // Adicionar controle de qualidade para reduzir tamanho
    })

    return new File([convertedBlob as Blob], file.name.replace(/\.heic$/, ".webp"), { type: "image/webp" })
  } catch (error) {
    console.error("Error converting HEIC:", error)
    throw new Error("Failed to convert HEIC image. Try another image.")
  }
}

// Função auxiliar para verificar se um arquivo é HEIC
export function isHeicFile(file: File): boolean {
  return file.name.toLowerCase().endsWith(".heic") || file.type === "image/heic"
}

// Adicionar comentário webpack para nomear explicitamente o chunk
// Isso ajuda o webpack a identificar e otimizar melhor o chunk
